export enum JOURNEY_PAGE_TEMPLATE_ID {
  FAIRTRADE = 'fairtrade',
}
